"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRedux = require("react-redux");

var _fiverReactUiComponents = require("fiver-react-ui-components");

require("moment/locale/nl");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n\n  &::before {\n    content: \"\";\n    width: 20rem;\n    height: 20rem;\n    position: absolute;\n    top: -100px;\n    left: 0;\n    background: ", ";\n    transform: rotate(-65deg);\n  }\n"])), function (p) {
  return p.theme.colorPicksBannerForeground;
});

var StyledContent = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));

var StyledLabel = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorPicksBannerLabel || "rgba(255, 255, 255, 0.65)";
});

var StyledValue = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 1.5rem;\n  font-weight: 700;\n"])));

var Wrapper = function Wrapper(_ref) {
  var kickoff = _ref.kickoff,
      translations = _ref.translations,
      language = _ref.language;
  var locale;
  var timezone;

  if (language === "dutch") {
    locale = "nl";
    timezone = "Europe/Amsterdam";
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledContent, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLabel, {
        children: translations.start
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledValue, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.DateTime, {
          format: "ddd H:mm",
          locale: locale,
          timezone: timezone,
          children: kickoff
        })
      })]
    })
  });
};

var _default = Wrapper;
exports.default = _default;